import React, { useEffect, useState } from "react";
import "./image-popup.scss";


const imageUrl = "/images/pop.png";

export default function ImagePopup() {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);

    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (!open) return null;

  return (
    <div className="mh-popup-overlay" role="dialog" aria-modal="true">
      <div className="mh-popup-content">
        <div className="mh-popup-image-wrap" onClick={() => setOpen(false)}>
          <div className="mh-popup-image-box">
            <button
              className="mh-popup-close"
              aria-label="Close popup"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
            >
              ×
            </button>
            <img
              src={imageUrl}
              alt="Popup"
              className="mh-popup-image"
              onClick={() => setOpen(false)}
            />
          </div>
        </div>
      </div> 
    </div>
  );
}
